import Page from "../../components/Page";
import Form from "./components/Form";
import Table from "./components/Table";
import { DocumentsProvider } from "./context/DocumentsContext";

export default function HomePage() {
  return (
    <Page title="Documentos">
      <DocumentsProvider>
        <Form />
        <Table />
      </DocumentsProvider>
    </Page>
  );
}
